// extracted by mini-css-extract-plugin
module.exports = {"uploadButton":"UploadButton_uploadButton__1L7c5","icon":"UploadButton_icon__2G4yy","text":"UploadButton_text__2Psrt"};